import React, { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { buildActivityChartData } from "./developerUtils";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Filler);

function ActivityChart({ games }) {
  const chartPayload = useMemo(() => buildActivityChartData(games), [games]);

  const data = {
    labels: chartPayload.labels,
    datasets: [
      {
        label: "Assigned playtesters",
        data: chartPayload.playtesterCounts,
        borderColor: "#e879f9",
        backgroundColor: "rgba(232, 121, 249, 0.15)",
        pointBackgroundColor: "#e879f9",
        pointBorderColor: "#fdf4ff",
        pointRadius: 3,
        pointHoverRadius: 5,
        tension: 0.35,
        fill: true,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#1c1b28",
        borderColor: "rgba(255,255,255,0.1)",
        borderWidth: 1,
        titleColor: "#f4f4f5",
        bodyColor: "#9ca3af",
        padding: 10,
      },
    },
    scales: {
      x: {
        grid: { color: "rgba(255,255,255,0.04)" },
        ticks: { color: "#6b7280", font: { size: 10 } },
      },
      y: {
        beginAtZero: true,
        grid: { color: "rgba(255,255,255,0.04)" },
        ticks: {
          color: "#6b7280",
          font: { size: 10 },
          stepSize: 1,
        },
      },
    },
  };

  return (
    <div className="dev-chart-wrap">
      <Line data={data} options={options} />
    </div>
  );
}

export default ActivityChart;
